$(document).ready(function() {
    const $filterBar = $('.filter-bar');
    const $sections = $('.section-block');
    const $filterLinks = $('.section-nav a');
    const filterBarHeight = $filterBar.outerHeight();
    const headerHeight = $('#siteHeader').outerHeight();
    const offset = headerHeight + filterBarHeight;
    
    // Smooth scroll to section when clicking filter
    $filterLinks.on('click', function(e) {
        e.preventDefault();
        const $this = $(this);
        const target = $this.attr('href');
        const $targetSection = $(target);
        
        $('html, body').animate({
            scrollTop: $targetSection.offset().top - offset
        }, 500);

        // Close dropdown
        $this.closest('.filter-buttons').removeClass('is-open');
        $this.closest('.filter-dropdown').find('.filter-label').removeClass('is-open');
    });
    
    // Update active filter on scroll
    $(window).on('scroll', function() {
        const scrollPosition = $(window).scrollTop() + offset + 100; // Add small buffer
        
        $sections.each(function() {
            const $section = $(this);
            const sectionTop = $section.offset().top;
            const sectionBottom = sectionTop + $section.outerHeight();
            
            if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
                const sectionId = $section.attr('id');
                $filterLinks.removeClass('is-active');
                $(`.section-nav a[href="#${sectionId}"]`).addClass('is-active');
                $filterLinks.closest('.filter-dropdown').find('.filter-label span').text($('.section-nav a.is-active').text());
            }
        });
    });
    
    // Handle fixed positioning for filter bar
    function updateFilterBarPosition() {
        const headerHeight = $('#siteHeader').outerHeight();
        const $filterBar = $('.filter-bar');
        const filterBarTop = $filterBar.offset().top - headerHeight;
        
        $(window).on('scroll', function() {
            const scrollTop = $(window).scrollTop();
            
            if (scrollTop >= filterBarTop) {
                $filterBar.addClass('is-sticky');
            } else {
                $filterBar.removeClass('is-sticky');
            }
        });
        
        $filterBar.css('top', headerHeight + 'px');
    }
    
    // Update on resize
    if($('.filter-bar').length) {
        $(window).on('resize', updateFilterBarPosition);
        updateFilterBarPosition();
    }
}); 

// Adjust iframe height for podcast embeds
function adjustIframeHeight() {
    const iframes = document.querySelectorAll('.podcast-single .embed-item iframe');
    
    iframes.forEach(iframe => {
        // Listen for the iframe to load
        iframe.onload = () => {
            try {
                // Try to get content height from iframe
                const height = iframe.contentWindow.document.body.scrollHeight;
                iframe.style.height = `${height}px`;
            } catch(e) {
                // If cross-origin, we'll need to use postMessage API
                // Most embed providers (YouTube, Spotify) handle this automatically
                // console.log('Cross-origin iframe, using default height');
            }
        };
    });
}

// Run on page load
document.addEventListener('DOMContentLoaded', adjustIframeHeight);